import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
const breeds = [{
  name: 'Perro Salchicha',
  color: 'from-amber-200 to-amber-100'
}, {
  name: 'Golden Retriever',
  color: 'from-amber-100 to-amber-50'
}, {
  name: 'Bulldog Francés',
  color: 'from-gray-200 to-gray-100'
}, {
  name: 'Labrador',
  color: 'from-yellow-100 to-yellow-50'
}, {
  name: 'Poodle / Caniche',
  color: 'from-stone-200 to-stone-100'
}, {
  name: 'Chihuahua',
  color: 'from-orange-100 to-orange-50'
}, {
  name: 'Husky Siberiano',
  color: 'from-slate-200 to-blue-50'
}, {
  name: 'Pastor Alemán',
  color: 'from-amber-200 to-amber-100'
}, {
  name: 'Corgi',
  color: 'from-orange-200 to-orange-100'
}, {
  name: 'Gato Siamés',
  color: 'from-stone-200 to-stone-100'
}, {
  name: 'Gato Persa',
  color: 'from-gray-100 to-white'
}, {
  name: 'Maine Coon',
  color: 'from-stone-300 to-stone-200'
}];
export function BreedGallery() {
  return <section id="galeria" className="py-16 md:py-24 bg-linen" data-id="element-32">
      <div className="max-w-6xl mx-auto px-4" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-34">
          <span className="text-soft-rose font-bold tracking-[0.2em] text-sm uppercase" data-id="element-35">
            La Colección
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mt-3 mb-4" data-id="element-36">
            ¿Cuál es tu compañero de vida?
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-37">
            Hemos incluido las razas más amadas. Encuentra la tuya y comienza a
            tejer su versión mini.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-id="element-38">
          {breeds.map((breed, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="group cursor-pointer" data-id="element-39">
              <div className="etsy-card etsy-card-hover overflow-hidden" data-id="element-40">
                <div className={`aspect-square bg-gradient-to-br ${breed.color} flex items-center justify-center relative`} data-id="element-41">
                  <span className="text-deep-brown/10 font-heading text-5xl font-bold select-none" data-id="element-42">
                    {breed.name.charAt(0)}
                  </span>

                  <div className="absolute top-3 right-3 bg-white/90 p-1.5 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-43">
                    <Heart size={14} className="text-soft-rose fill-soft-rose" data-id="element-44" />
                  </div>
                </div>

                <div className="p-3 text-center" data-id="element-45">
                  <h3 className="font-bold text-deep-brown text-sm group-hover:text-warm-brown transition-colors" data-id="element-46">
                    {breed.name}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-47">
          <p className="text-sm text-gray-400 italic" data-id="element-48">
            * Todos los patrones incluyen instrucciones para adaptar colores y
            manchas.
          </p>
        </div>
      </div>
    </section>;
}